import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

import ClickToCloseWrapper from "components/library/ClickToCloseWrapper";
import styles from "./DropdownMenu.css";

export default class DropdownMenu extends React.Component {
  render() {
    return (
      <ClickToCloseWrapper
        className={classNames(styles.root, this.props.className)}
        visibleClassName={styles.visible}
        isVisible={this.props.isVisible}
        onClose={this.props.onClose}
        closeOnFirstClick={this.props.closeOnFirstClick}
      >
        <nav>
          <ul>
            {React.Children.map(this.props.children, el => {
              return (
                el && (
                  <li className={styles.item} role="menuitem">
                    {el}
                  </li>
                )
              );
            })}
          </ul>
        </nav>
      </ClickToCloseWrapper>
    );
  }
}

DropdownMenu.defaultProps = {
  isVisible: false,
};

DropdownMenu.propTypes = {
  closeOnFirstClick: PropTypes.bool,
  isVisible: PropTypes.bool,
  className: PropTypes.string,
  onClose: PropTypes.func,
};
